export default "__VITE_ASSET__CcBBQgIE__"